import React, { Component } from 'react';
import {
  Text,
  View,
  ScrollView,
  Dimensions,
  Keyboard,
  TouchableWithoutFeedback,
  Alert,
  TouchableOpacity,
  Platform,
} from '../../src/web/react-native';
import { connect } from 'react-redux';
import Icon from '../../src/components/Icon';
import Service from './../../Service/service';
import { shiftLogActions } from '../../src/store';
import {
  GetShiftLogsActionAsync,
  GetTeamShiftLogsActionAsync,
  UpdateShiftLogActionAsync,
  UpdateTeamShiftLogActionAsync,
  AddShiftLogsActionAsync,
} from './../../Action/ShiftLogAction';
import { LoadingOverlay, RichTextField } from '../../src/components';
import moment from 'moment';
import { unwrapResult } from '@reduxjs/toolkit';
import { Route } from '../../src/app/Route';
import { DdLogs } from '../../src/logging/datadog';
export class TakeOverSubmit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      scrollOffset: null,
      comments: '',
      user: '',
      width: Dimensions.get('window').width,
      height: Dimensions.get('window').height,
    };
  }
  handleOnScroll = (event) => {
    this.props.setScrollOffset(event.nativeEvent.contentOffset.y);
  };
  async componentDidMount() {
    const user = this.props.user;
    this.setState({
      user: user.name,
    });
    Dimensions.addEventListener('change', () => {
      this.setState({
        width: Dimensions.get('window').width,
        height: Dimensions.get('window').height,
      });
    });
  }
  handleOnTakeOverSubmit = async () => {
    let { shiftSummaryID } = this.props;
    let localPreference = await Service.getLocalPreferences();
    this.props
      .SubmitTakeOver(localPreference.site.siteCode, shiftSummaryID, this.state.comments)
      .then(unwrapResult)
      .then(() => {
        if (this.props.isTeamLog) {
          this.props.UpdateTeamShiftLog(
            localPreference.site.siteCode,
            this.props.preference.assetName,
            shiftSummaryID,
          );
        } else {
          this.props.UpdateShiftLog(
            localPreference.site.siteCode,
            this.props.preference.assetName,
            shiftSummaryID,
          );
        }
        setTimeout(() => {
          Alert.alert(
            'Successfully Completed',
            'Your take over has been successfully done on ' +
              moment(Date.now()).format('MMM DD, YYYY h:mm a'),
            [
              {
                text: 'OK',
                onPress: () => {
                  this.props.closeModal(false);
                  this.props.navigation.navigate(Route.reportScreen, {
                    previousScreen: Route.logDetailsScreen,
                  });
                },
              },
            ],
          );
        }, 200);
      })
      .catch((_err) => {
        setTimeout(() => {
          Alert.alert('Error', this.props.submitErroMessage, [
            {
              text: 'OK',
              onPress: () => {},
            },
          ]);
        }, 200);
      });
  };
  render() {
    const width = this.state.width * 0.9;
    const height = this.state.height;
    return (
      <View
        style={{
          alignItems: 'center',
          backgroundColor: '#fff',
          height: 0.7 * height,
          borderRadius: 5,
        }}>
        {<LoadingOverlay visible={this.props.submitInProgress} />}
        <TouchableWithoutFeedback onPress={() => Keyboard.dismiss()}>
          <ScrollView
            contentContainerStyle={{}}
            onScroll={this.handleOnScroll}
            ref={this.props.scrollViewRef}
            scrollEventThrottle={1}>
            <View
              style={{
                minHeight: 30,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <View
                style={{
                  width: width,
                  height: 50,
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  backgroundColor: '#fff',
                  paddingHorizontal: 15,
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                }}>
                <Text style={{ color: '#00A3E0', fontWeight: 'bold', fontSize: 16 }}>
                  Take Over
                </Text>
                <TouchableOpacity
                  onPress={() => {
                    this.props.closeModal(false);
                  }}>
                  <Text style={{ textAlign: 'center' }}>
                    <Icon name="ios-close" size={30} color="#8D8D8D" />
                  </Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  height: 5,
                  backgroundColor: '#fff',
                  width: width,
                  shadowOffset: { height: 5 },
                  shadowOpacity: 1,
                  shadowColor: '#E1E8EB',
                  elevation: 5,
                  marginBottom: 15,
                }}
              />
              <View
                style={{
                  width: width,
                  marginBottom: 15,
                  paddingHorizontal: 15,
                  justifyContent: 'flex-start',
                  backgroundColor: '#fff',
                }}>
                <Text style={{ color: '#5A5A5A' }}>Take Over User</Text>
                <Text style={{ paddingTop: 10, fontWeight: 'bold', fontSize: 16 }}>
                  {this.state.user}
                </Text>
              </View>
              <View
                style={{
                  backgroundColor: '#0000001A',
                  height: 1,
                  width: width,
                }}
              />
              {this.props.takeoverDisplay &&
                this.props.rowData.map((val, ind) => {
                  return Object.keys(val).map((key) => {
                    DdLogs.info('key' + key);

                    return (
                      <View
                        style={{
                          width: width,
                          marginVertical: 2,
                          paddingHorizontal: 15,
                          justifyContent: 'flex-start',
                          backgroundColor: '#fff',
                        }}
                        key={key}>
                        <Text style={{ color: '#5A5A5A' }}>{key}</Text>
                        <Text
                          style={{
                            paddingTop: 1,
                            fontWeight: 'bold',
                            fontSize: 16,
                          }}>
                          {val[key] ? val[key] : ''}
                        </Text>
                      </View>
                    );
                  });
                })}
              <View
                style={{
                  backgroundColor: '#0000001A',
                  height: 1,
                  width: width,
                }}
              />

              <View
                style={{
                  width: width,
                  marginVertical: 15,
                  paddingHorizontal: 15,
                }}>
                <Text style={{ color: '#5A5A5A', marginBottom: 10 }}>Comments</Text>
                <RichTextField
                  placeholder={'Leave comments here...'}
                  style={{
                    borderColor: '#ccc',
                    borderWidth: 1,
                    height: Platform.OS === 'ios' ? 200 : undefined,
                    padding: 10,
                  }}
                  onChange={(e) => {
                    this.setState({
                      comments: e.nativeEvent.text,
                    });
                  }}
                />
              </View>

              <TouchableOpacity
                style={{}}
                onPress={() => {
                  this.handleOnTakeOverSubmit();
                }}>
                <View
                  style={{
                    height: 48,
                    width: width - 30,
                    backgroundColor: '#0C479D',
                    borderRadius: 4,
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginVertical: 10,
                  }}>
                  <Text style={{ color: '#fff', fontWeight: 'bold' }}>Take Over</Text>
                </View>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </TouchableWithoutFeedback>
      </View>
    );
  }
}

const mapStateToProps = (state) => ({
  shiftLogs: state.ShiftLogsReducer.shiftLogs,
  preference: state.preference.preferences,
  user: state.user.user,
  submitInProgress: state.shiftLogs.submitTakeOverInProgress,
  submitErroMessage: state.shiftLogs.submitTakeOverErrorMessage,
  // isLoading: state.ShiftLogsReducer.isLoading
});

const mapDispatchToProps = (dispatch) => {
  return {
    GetShiftLogs: (preference) => {
      DdLogs.info('take over submit.js');
      return dispatch(
        GetShiftLogsActionAsync({
          siteCode: preference.site.siteCode,
          assetName: Service.getShiftLogAssetName(preference),
        }),
      );
    },
    GetTeamShiftLogs: (preference) => {
      DdLogs.info('takeover submit teamlog');
      return dispatch(
        GetTeamShiftLogsActionAsync({
          siteCode: preference.site.siteCode,
          assetName: Service.getShiftLogAssetName(preference),
        }),
      );
    },
    UpdateShiftLog: (siteCode, assetName, shiftSummaryID) => {
      return dispatch(
        UpdateShiftLogActionAsync({
          siteCode,
          assetName,
          shiftSummaryID,
        }),
      );
    },
    UpdateTeamShiftLog: (siteCode, assetName, shiftSummaryID) => {
      return dispatch(
        UpdateTeamShiftLogActionAsync({
          siteCode,
          assetName,
          shiftSummaryID,
        }),
      );
    },
    AddTeadmShiftLog: (item) => {
      return dispatch(AddShiftLogsActionAsync(item));
    },
    SubmitTakeOver: (siteCode, shiftSummaryID, takeoverComments) => {
      return dispatch(
        shiftLogActions.submitTakeOver({
          siteCode: siteCode,
          shiftSummaryID: shiftSummaryID,
          takeoverComments: takeoverComments,
        }),
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TakeOverSubmit);